(function () {
  if (window.uxVideoInit) return;
  window.uxVideoInit = true;

  const WRAP = '.ux-video__media-wrap';
  let dialog = null;
  let popupVideo = null;

  const build = () => {
    if (dialog || !document.body) return;
    dialog = document.createElement('dialog');
    dialog.className = 'ux-video-popup';
    dialog.innerHTML =
      '<button type="button" class="ux-video-popup__close" data-ux-video-close aria-label="Close"></button>' +
      '<video class="ux-video-popup__video" controls playsinline></video>';
    document.body.appendChild(dialog);
    popupVideo = dialog.querySelector('video');
    dialog.addEventListener('close', () => {
      popupVideo.pause();
      popupVideo.removeAttribute('src');
      popupVideo.load();
    });
  };

  const sourceOf = (video) => {
    if (video.currentSrc) return video.currentSrc;
    const s = video.querySelector('source');
    return s ? s.src : '';
  };

  document.addEventListener('mouseover', (e) => {
    const wrap = e.target.closest(WRAP);
    if (!wrap) return;
    const v = wrap.querySelector('video');
    if (v && v.paused) v.play().catch(() => {});
  });

  document.addEventListener('mouseout', (e) => {
    const wrap = e.target.closest(WRAP);
    if (!wrap || wrap.contains(e.relatedTarget)) return;
    const v = wrap.querySelector('video');
    if (v) {
      v.pause();
      v.currentTime = 0;
    }
  });

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-ux-video-close]')) {
      if (dialog) dialog.close();
      return;
    }
    if (dialog && e.target === dialog) {
      dialog.close();
      return;
    }
    const wrap = e.target.closest(WRAP);
    if (!wrap) return;
    const tileVideo = wrap.querySelector('video');
    if (!tileVideo) return;
    const src = sourceOf(tileVideo);
    if (!src) return;
    build();
    popupVideo.src = src;
    popupVideo.currentTime = 0;
    if (typeof dialog.showModal === 'function') dialog.showModal();
    popupVideo.play().catch(() => {});
  });
})();
